import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import Hero from './Hero';
import Menu from './Menu';
import Pricing from './Pricing';
import About from './About';
import Testimonials from './Testimonials';
import OrderForm from './OrderForm';
import Footer from './Footer';

const LandingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (!targetId) return;

    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }

    navigate(location.pathname, { replace: true, state: {} });
  }, [location, navigate]);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <div id="hero">
          <Hero />
        </div>
        <Menu />
        <Pricing />
        <About />
        <Testimonials />
        <OrderForm />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
